<style lang="scss">
  @use "../../components/shared/tab-body.scss";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/_colors.scss"
    as colors;
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils.scss"
    as utils;
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/_mixins.scss"
    as mixins;

  .contact-stages {
    height: 100%;
  }

  .notice {
    margin-top: utils.in_rem(8px);
    margin-bottom: utils.in_rem(32px);
    p {
      @include mixins.body2();
    }
  }
</style>

<script>
  import InlineNotification from "@sourcewhale/shared/svelte-design-system/components/atoms/InlineNotification.svelte";
  import CustomTabs from "../../components/shared/CustomTabs.svelte";
  import Description from "../../components/shared/Description.svelte";
  import TabContent from "../../components/shared/TabContent.svelte";
  import { activeProviderConfigStore, integrationStore } from "../../stores";
  import StageMapping from "./components/StageMapping.svelte";

  $: providerTitle = $integrationStore.getProviderTitle();
  $: learnMoreLink = $integrationStore.getLearnMoreLink("contactStages");

  $: description = {
    title: "Contact Stages",
    description: `Below shows the different outreach stages in SourceWhale that contacts can move through, you can map them to stages in ${providerTitle} to keep progress aligned.`,
    learnMoreLink,
  };

  $: notice = `This section is optional - you don't need to map every stage to ${providerTitle} if you don't track it.`;

  const tabItems =
    $activeProviderConfigStore?.syncKinds?.map((kind, index) => ({
      label: kind === "ClientContact" ? "CONTACT" : kind.toUpperCase(),
      slot: `tab${index}`,
      kind,
    })) || [];

  let currentType;

  $: hasStages =
    $integrationStore.getSettings("stages", $currentType)?.length > 0;
</script>

<div class="contact-stages tab-body">
  <Description {...description} />

  <div class="notice">
    <InlineNotification>
      <p>{notice}</p>
    </InlineNotification>
  </div>

  <CustomTabs {tabItems} bind:currentType />
  <TabContent
    hasData={hasStages}
    tabCount={tabItems.length}
    emptyMessage="No stage mappings available for this type."
  >
    <StageMapping type={$currentType} />
  </TabContent>
</div>
